import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || 'https://api.noxpn.site';
const publicApi = axios.create({ baseURL, headers: { 'Content-Type': 'application/json' } });
const adminApi = axios.create({ baseURL, headers: { 'Content-Type': 'application/json' } });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('vpn_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if ([401, 403].includes(error.response?.status)) {
      localStorage.removeItem('vpn_admin_token');
      window.dispatchEvent(new Event('vpn:admin-unauthorized'));
    }
    return Promise.reject(error);
  },
);

export const loginAdmin = async (email, password) => (await publicApi.post('/auth/admin/login', { email, password })).data;
export const getAdminMe = async () => (await adminApi.get('/auth/admin/me')).data;
export const getAdminStatistics = async () => (await adminApi.get('/admin/statistics')).data;
export const getAdminUsers = async () => (await adminApi.get('/admin/users')).data;
export const updateAdminUser = async (id, changes) => (await adminApi.patch(`/admin/users/${id}`, changes)).data;
export const deleteAdminUser = async (id) => adminApi.delete(`/admin/users/${id}`);
export const changeUserBalance = async (id, amount) => (await adminApi.post('/admin/users/balance', { user_ids: [id], amount })).data;
export const runUserVpnAction = async (id, action) => (await adminApi.post(`/admin/users/${id}/vpn/${action}`)).data;
export const resetUserDevices = async (id) => (await adminApi.delete(`/admin/users/${id}/devices`)).data;
export const getAdminSubscriptions = async () => (await adminApi.get('/admin/subscriptions')).data;
export const getAdminPayments = async () => (await adminApi.get('/admin/payments')).data;

export default adminApi;
